import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBv_xda3OIDDVQUemPi3hbqYG1LgfBjOWM",
  authDomain: "jampp-73686.firebaseapp.com",
  projectId: "jampp-73686",
  storageBucket: "jampp-73686.firebasestorage.app",
  messagingSenderId: "552372304050",
  appId: "1:552372304050:web:1554add26e6e8ee6a031ab",
  measurementId: "G-56D1KCY525"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

export default app;